import React, { useState } from 'react';

function LoginForm({ onLogin }) {
  const [formData, setFormData] = useState({
    companyId: '',
    employeeId: '',
    password: ''
  });
  const [error, setError] = useState('');

// handleSubmit関数を修正
const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');

  try {
    console.log('ログインリクエスト送信:', formData);
    const response = await fetch('https://kintai-gps-kanri.com/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();
    console.log('サーバーレスポンス:', data);

    if (!response.ok) {
      throw new Error(data.message || 'ログインに失敗しました');
    }

    // トークンとユーザー情報を保存
    localStorage.setItem('token', `Bearer ${data.token}`);
    localStorage.setItem('userInfo', JSON.stringify(data.user));
    
    // ログイン成功後の処理
    window.location.href = '/time-clock';
  } catch (error) {
    console.error('ログインエラー:', error);
    setError('企業ID、社員ID、またはパスワードが正しくありません。');
  }
};

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-8">
          勤怠管理システム
        </h2>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              企業ID
            </label>
            <input
              type="text"
              name="companyId"
              value={formData.companyId}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              社員ID
            </label>
            <input
              type="text"
              name="employeeId"
              value={formData.employeeId}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              パスワード
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {error && (
            <div className="text-red-500 text-sm text-center">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            ログイン
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
